import React from "react";
import { Route } from "react-router-dom";
import { useSelector } from 'react-redux';

import Bookings from './pages/bookings';
import Booking from './pages/booking';
import BookingCreate from './pages/create';
import PayoutCreate from './pages/booking/views/create-payout';

import RedirectRenderer from "src/components/redirect-renderer";
import HasFeature from "src/utils/has-feature";
import HasRole from "src/utils/has-role";
import GroupMenu from "src/components/group-menu";

import { BriefcaseIcon } from "@heroicons/react/24/outline";
import GroupContainer from "src/components/group-container";

const Layout = ({ children }) => {
  const items = [
    { name: 'Bookings', description: "Create, manage, and track bookings", icon: BriefcaseIcon, path: '/bookings', check: true },

    { name: 'Create Booking', parent: 'Bookings', description: 'Create a booking for your customer', visible: false, path: '/bookings/create', check: true },

    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id', check: true },
    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id/elements', check: true },
    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id/transactions', check: true },
    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id/credit-notes', check: true },
    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id/scheduled-transactions', check: true },
    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id/payouts', check: true },
    { name: 'Booking', parent: 'Bookings', description: 'View, edit, and manage a booking', visible: false, path: '/booking/:id/supplier-payments', check: true },
  ];
  
  return (
    <div id="content">
      <GroupMenu items={items} title="Bookings" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

const redirects = [];

const BookingsRoutes = () => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  if (account?.id && HasFeature(features, ['booking-and-payment'])) {
    return (
      <React.Fragment>

        {RedirectRenderer({ redirects })}

        <Route exact path={`/bookings`} component={() => <Layout><Bookings /></Layout>} />

        <Route exact path={`/booking/:id`} component={() => <Layout><Booking /></Layout>} />
        <Route exact path={`/booking/:id/elements`} component={() => <Layout><Booking /></Layout>} />
        <Route exact path={`/booking/:id/transactions`} component={() => <Layout><Booking /></Layout>} />
        <Route exact path={`/booking/:id/credit-notes`} component={() => <Layout><Booking /></Layout>} />
        <Route exact path={`/booking/:id/scheduled-transactions`} component={() => <Layout><Booking /></Layout>} />

        {HasRole(account, ['booking-and-payment:create:booking']) && (
          <Route exact path={`/bookings/create`} component={() => <Layout><BookingCreate /></Layout>} />
        )}

        {HasRole(account, ['payouts:view']) && HasFeature(features, ['payouts']) && (
          <Route exact path={`/booking/:id/payouts`} component={() => <Layout><Booking /></Layout>} />
        )}

        {HasFeature(features, ['aisp']) && (
          <Route exact path={`/booking/:id/supplier-payments`} component={() => <Layout><Booking /></Layout>} />
        )}

        {HasRole(account, ['payouts:view', 'payouts:create']) && HasFeature(features, ['payouts', 'supplier-payouts']) && (
          <Route exact path={`/payout/create`} component={PayoutCreate} />
        )}

      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default BookingsRoutes;
